import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import {
    PERMISSION,
    useConnectorIdentity,
} from '~/hooks/auth/useConnectorIdentity';

/**
 * Who the connector is treating this session as.
 *
 * Shown because the answer is not obvious to the person it concerns: the
 * identity comes from the workstation's own sign-in rather than from anything
 * done in this application, so on a shared clinical workstation the only way to
 * know which account is acting is to be told.
 */
export default function SignedInAccount() {
    const identity = useConnectorIdentity();

    if (!identity.signInEnabled || !identity.account) {
        return null;
    }

    return (
        <Box display="flex" alignItems="center" gap={0.5}>
            <Tooltip title={identity.account}>
                <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{
                        maxWidth: 180,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                    noWrap
                >
                    {identity.displayName ?? identity.account}
                </Typography>
            </Tooltip>

            {/* Offered only to somebody who may use it: a link that answers 403
                tells a clinician they have done something wrong when they have not.
                A new tab, so the patient open here is never left behind. */}
            {identity.can(PERMISSION.systemAdministration) && (
                <Tooltip title="Administration console (opens in a new tab)">
                    <IconButton
                        size="small"
                        href="/admin"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Administration console (opens in a new tab)"
                    >
                        <SettingsOutlinedIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            )}
        </Box>
    );
}
